// Dynamic import keeps Analytics initialization off the page's render dependency chain.
// Calls made while the module loads are queued by the import promise.
export function logEvent(...args) {
  import('@local-utils/firebase')
    .then((analytics) => analytics.logEvent(...args))
    .catch((error) => console.warn('Analytics unavailable', error));
}
